module.exports = __webpack_public_path__ + "img/italy.0d9fdcb5.svg";